<template>
    <div class="seperator-x"></div>
</template>

<script>
export default {
    name: "SeperatorX"
}
</script>

<style lang="scss">
.seperator-x {
    height: 2px;
    background-color: #dbdbdb;
}
</style>
